module.exports = __webpack_public_path__ + "static/img/mobile-img@w.0f5bb4b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/mobile-img@w.png
// module id = y0+W
// module chunks = 0